import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Category, Data, InventoryManager, Item, MenuManager, OrderManager, Setting} from 'aigens-ng-core';
import {OrderService} from '../../core/services/order.service';
import {SystemConfigService} from 'src/app/core/services/systemConfig.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-grid-layout-item-double',
    templateUrl: './grid-layout-item-double.html',
    styleUrls: ['./grid-layout-item-double.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush
    // 打开后 在购物车修改状态返回item-grid-scroll 状态不会更改
})
export class GridLayoutItemDouble implements OnInit {
    settings: Setting;
    isEn: boolean;
    mode: string;
    urls = [];
    itemName = [];
    isSoldout = [];
    isSet = [];
    @Output() addClick = new EventEmitter();
    @Output() removeClick = new EventEmitter();

    @Input() currencySign: string;
    @Input() tagsImage;
    @Input() defaultImage;
    @Input() orderManager: OrderManager;

    isShowLogo = true; // control the cat-item list-mode when img is null then if show the logo

    // tslint:disable-next-line: max-line-length
    constructor(private cdr: ChangeDetectorRef, private translateService: TranslateService,
                private inventoryManager: InventoryManager, private orderService: OrderService,
                private menuManager: MenuManager, public systemConfigService: SystemConfigService) {

        this.settings = this.orderService.getCurrentStoreSetting();
        // todo init the isShowLogo
        this.isShowLogo = this.systemConfigService['systemConfig'] && this.systemConfigService['systemConfig']['data'] && this.systemConfigService['systemConfig']['data']['showLogo'];
        console.log('isShowLogo:', this.isShowLogo);

    }

    _items: Item[];

    @Input()
    set items(input: Item[]) {
        this._items = input;
        let tempUrls = [];
        let tempItemName = [];
        let tempIsSoldout = [];
        let tempIsSet = [];

        for (let item of this._items) {
            let temp = this.getItemImage(item);
            tempUrls.push(`url(${temp})`);
            tempItemName.push(this.getItemName(item));
            const now = Date.now();
            if (this._category) {
                tempIsSoldout.push(this.getSoldout(item, now));
                tempIsSet.push(this.getIsSet(item));
            }
        }
        this.urls = tempUrls;
        this.itemName = tempItemName;
        if (this._category)
            this.isSoldout = tempIsSoldout;
    }

    _category: Category;

    @Input()
    set category(input: Category) {
        this._category = input;
        this.mode = this._category && this._category.layout && this._category.layout !== 'none' ? this._category.layout : this.settings.itemLayout;
        if (this._category && this._items && this._items.length > 0) {
            let tempIsSoldout = [];
            let tempIsSet = [];
            const now = Date.now();
            for (let item of this._items) {
                tempIsSoldout.push(this.getSoldout(item, now));
                tempIsSet.push(this.getIsSet(item));

            }
            this.isSoldout = tempIsSoldout;
            this.isSet = tempIsSet;
        }
    }

    ngOnInit() {
    }

    getIsSet(item) {
        return Item.isSet(this._category, item);
    }

    getItemName(item) {
        let name: string = item.name;

        if (!!(item.variations && item.variations.length > 0)) {
            name = item.title;
        }

        if (!name || name.length === 0) {
            name = item.name;
        }

        return name;
    }

    getItemImage(item: Item) {
        let url: string;
        if (item.featured) {
            if (item.images && item.images['hero'] && item.images['hero']['url']) url = item.images['hero']['url'];
        } else {
            url = Data.getImage(item, 'default', 150, true);
        }

        return url || this.defaultImage;
    }

    getItemImageWithoutDefault(item: Item) {
        let url: string;
        if (item.featured) {
            if (item.images && item.images['hero'] && item.images['hero']['url']) url = item.images['hero']['url'];
        } else {
            url = Data.getImage(item, 'default', 150, true);
        }
        return url;
    }

    getSoldout(item, now): boolean {
        let result: boolean;
        const imSoldout = this.inventoryManager.isSoldout(item);
        result = (!(!!(item.variations && item.variations.length > 0)) && imSoldout);
        return result || !this.menuManager.isAvailableCombo(this.orderManager.store, this._category, item, this.orderManager.isTakeout(), now);
    }

    removeClicked(item) {
        this.removeClick.emit({
            item, callBack: () => {
                this.cdr.detectChanges();
            }
        });
    }

    addClicked(item) {
        this.addClick.emit({
            item, callBack: () => {
                this.cdr.detectChanges();
            }
        });
    }


}
